import React from "react";

import WorkspaceLayout from "./WorkspaceLayout";
import { WORKSPACE_TYPES } from "../config/navigation";
import { useUser } from "../contexts/UserContext";

export default function AdminLayout({ children }) {
  const { user } = useUser();

  return (
    <WorkspaceLayout
      workspaceType={WORKSPACE_TYPES.INTERNAL}
      title="Ecovanta Workspace"
      subtitle="Internal CRM, advisory, and platform operations"
      user={user}
    >
      {children}
    </WorkspaceLayout>
  );
}